var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 70,
    viewBox: "0 0 56 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_48_1783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.65243C0 1.63525 1.63525 0 3.65243 0H52.3476C54.3647 0 56 1.63525 56 3.65243V66.3476C56 68.3648 54.3647 70 52.3476 70H3.65243C1.63525 70 0 68.3648 0 66.3476V3.65243Z",
    fill: "#AD4123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7217 43.5H21.8917C21.5734 43.5 21.2768 43.3394 21.1012 43.0731L16.1544 35.5179C15.9485 35.2034 15.9485 34.7973 16.1544 34.4828L21.1012 26.9276C21.2768 26.6613 21.5734 26.5007 21.8917 26.5007H37.7217C38.2439 26.5007 38.6661 26.9229 38.6661 27.4451V42.5556C38.6661 43.0779 38.244 43.5 37.7217 43.5ZM33.6674 30.5551C33.4832 30.3709 33.2415 30.2784 32.9997 30.2784C32.7579 30.2784 32.5161 30.3709 32.332 30.5551L29.222 33.665L26.1121 30.5551C25.9279 30.3709 25.6862 30.2784 25.4444 30.2784C25.2026 30.2784 24.9609 30.3709 24.7767 30.5551C24.4074 30.9243 24.4074 31.5212 24.7767 31.8905L27.8866 35.0004L24.7767 38.1103C24.4074 38.4796 24.4074 39.0764 24.7767 39.4457C25.1459 39.8149 25.7428 39.8149 26.1121 39.4457L29.222 36.3358L32.3319 39.4457C32.7012 39.8149 33.298 39.8149 33.6673 39.4457C34.0365 39.0764 34.0365 38.4796 33.6673 38.1103L30.5574 35.0004L33.6674 31.8905C34.0366 31.5212 34.0366 30.9243 33.6674 30.5551Z",
    fill: "#F4D1C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65243 2H52.3476V-2H3.65243V2ZM54 3.65243V66.3476H58V3.65243H54ZM52.3476 68H3.65243V72H52.3476V68ZM2 66.3476V3.65243H-2V66.3476H2ZM3.65243 68C2.73982 68 2 67.2602 2 66.3476H-2C-2 69.4693 0.530679 72 3.65243 72V68ZM54 66.3476C54 67.2602 53.2602 68 52.3476 68V72C55.4693 72 58 69.4693 58 66.3476H54ZM52.3476 2C53.2602 2 54 2.73982 54 3.65243H58C58 0.530679 55.4693 -2 52.3476 -2V2ZM3.65243 -2C0.53068 -2 -2 0.530676 -2 3.65243H2C2 2.73982 2.73982 2 3.65243 2V-2Z",
    fill: "#AB7F39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_48_1783",
    x: -4,
    y: -4,
    width: 64,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_48_1783"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_48_1783",
    result: "effect2_innerShadow_48_1783"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.eefeee9aa35fe7c3936f1422fe75b20a.svg";
export { ForwardRef as ReactComponent };